import { combineReducers } from 'redux';
import { ALL_CUSTOMERS_OPTION } from '../../query/queryConfig';

const isLoading = (state = false, action) => {
    switch (action.type) {
        case "USER_LOADING":
            state = action.payload;
            return state;
        default:
            return state;
    }
};

const isAuthenticated = (state = false, action) => {
    switch (action.type) {
        case 'IS_AUTHENTICATED':
            state = action.payload;
            return state;
        default:
            return state;
    }
};

const user = (state = [], action) => {
    switch (action.type) {
        case "SET_USER":
            state = action.payload
            return state;
        default:
            return state;
    }
}

const customerSelection = (state = ALL_CUSTOMERS_OPTION, action) => {
    switch (action.type) {
        case "CUSTOMER_SELECTION":
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export default combineReducers({
    isAuthenticated,
    isLoading,
    user,
    customerSelection,
});
